<template>
  <div class="d-flex justify-content-between">
    <div>
      <ul class="pagination" :class="paginationClass">
        <li class="page-item prev-page" :class="{disabled: value === 1}">
          <a class="page-link" aria-label="Previous" @click="prevPage">
            <span>«</span>
          </a>
        </li>
        <li class="page-item"
          v-for="item in range(minPage, maxPage)"
          :key="item"
          :class="{active: value === item}"
        >
          <a class="page-link" @click="changePage(item)">{{item}}</a>
        </li>
        <li class="page-item page-pre next-page" :class="{disabled: value === totalPages}">
          <a class="page-link" aria-label="Next" @click="nextPage">
            <span>»</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="d-flex" style="align-items: center">
      <div class="nowrap">Pro Seite:&nbsp;</div>
      <select class="custom-select" v-model="perPage">
        <option value="15">15</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="250">250</option>
        <option value="500">500</option>
        <option value="1000">1000</option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  name: 'l-pagination',
  props: {
    color: {
      type: String,
      default: '',
      validator: (value) => {
        return ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple'].includes(value)
      }
    },
    pageCount: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass () {
      return `pagination-${this.color}`
    },
    totalPages () {
      if (this.pageCount > 0) return this.pageCount
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage)
      }
      return 1
    },
    pagesToDisplay () {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages
      }
      return this.defaultPagesToDisplay
    },
    minPage () {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
        const newMaxPage = pagesToAdd + this.value
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1
        }
        return this.value - pagesToAdd
      } else {
        return 1
      }
    },
    maxPage () {
      if (this.value >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
        const newMaxPage = pagesToAdd + this.value
        if (newMaxPage < this.totalPages) {
          return newMaxPage
        } else {
          return this.totalPages
        }
      } else {
        return this.pagesToDisplay
      }
    },
    perPage: {
      get () {
        return this.$store.state.perPage
      },
      set (value) {
        this.$store.state.perPage = value
        this.$emit('changePerPage', value)
      }
    }
  },
  data () {
    return {
      defaultPagesToDisplay: 5
    }
  },
  methods: {
    range (min, max) {
      let arr = []
      for (let i = min; i <= max; i++) {
        arr.push(i)
      }
      return arr
    },
    changePage (item) {
      this.$emit('input', item)
    },
    nextPage () {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1)
      }
    },
    prevPage () {
      if (this.value > 1) {
        this.$emit('input', this.value - 1)
      }
    }
  },
  watch: {
    total (value) {
      this.$emit('input', 1)
    }
  }
}
</script>
